import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import AppDither from './AppDither';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AppDither />
  </React.StrictMode>
);
